import { Component, AfterViewInit, ElementRef } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-sinopse',
  templateUrl: './sinopse.component.html',
  styleUrls: ['./sinopse.component.css']
})
export class SinopseComponent implements AfterViewInit {

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    const animatedEls: NodeListOf<Element> = this.el.nativeElement.querySelectorAll('.anim');
    animatedEls.forEach((el: Element) => observer.observe(el));
  }

  scrollTo(selector: string, event: Event): void {
    event.preventDefault();
    const target = document.querySelector(selector) as HTMLElement;
    if (!target) return;
    const offset = window.innerWidth < 768 ? 20 : 10;
    window.scroll({ top: target.offsetTop - offset, behavior: 'smooth' });
  }
}
